/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Box,
  Button,
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { AllowanceBox, ContentHeading } from "../../style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
import useFullTimeEmployeeService from "./full-time-employee-service";
import { initialState } from "./full-time-employee-constant";
import { logger } from "../../../utils/logger";
import useLeavePolicyService from "../leave-policy-service";

const OrganizationFullTimeEmployee = ({ openSnackbar }) => {
  const {
    leaveLists,
    leaveListsInfo,
    pagination,
    setErrors,
    errors,
    leave,
    setLeave,
    handleChange,
    handleBlurFn,
    handleSubmit,
    handleUpdate,
  } = useFullTimeEmployeeService({ openSnackbar });

  const { adminLeaveListsInfo } = useLeavePolicyService();

  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLeaveId, setEditLeaveId] = useState(null);

  const handleClickOpen = () => {
    setLeave(initialState);
    setOpen(true);
    setErrors({});
    setIsEditMode(false);
  };

  const handleEditModalOpen = (data) => {
    setLeave(data);
    setOpen(true);
    setEditLeaveId(data?.leave_policy_id);
    setErrors({});
    setIsEditMode(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLeave(initialState);
    setErrors({});
  };

  const handleSubmitFn = async () => {
    const hasErrors = Object.values(errors).some(
      (error) => error !== undefined
    );

    let success = false;
    if (editLeaveId) {
      success = await handleUpdate(editLeaveId);
    } else {
      success = await handleSubmit();
    }
    logger.log(hasErrors, success, "dipronil");
    if (!success) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handlePagination = (direction) => {
    const nextPage =
      direction === "next" ? pagination.page + 1 : pagination.page - 1;
    if (nextPage > 0 && nextPage <= pagination.totalPages) {
      leaveLists(nextPage, pagination.pageSize);
    }
  };

  return (
    <>
      <ContentHeading>
        <Typography variant="h5" mb="0">
          Full Time Employees
        </Typography>

        <Button
          color="primary"
          variant="outlined"
          size="sm"
          onClick={handleClickOpen}
        >
          Add New
        </Button>
      </ContentHeading>

      {!leaveListsInfo.length ? (
        <AllowanceBox mb={20}>
          <Icon color={"denger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItem="center"
            mb={"0"}
            p={15}
          >
            No predefined Leave Configurations and Policy
          </Typography>
        </AllowanceBox>
      ) : (
        <>
          <Gap height={30} />
          <Flex gap={20} direction={"column"}>
            {leaveListsInfo.map((config, index) => (
              config?.leave_types?.leave_type_name !== "LOP" && config?.leave_types?.leave_type_name !== "Sanction Leave" && <AllowanceBox key={index}>
                <Row alignItems="center" gap={{ md: 10, lg: 10, xxl: 60 }}>
                  <Col md={2}>
                    <Box>
                      <Box className="label">Leave Type</Box>
                      <Box className="value">
                        {config?.leave_types?.leave_type_name}
                      </Box>
                    </Box>
                  </Col>
                  <Col md={5} xl={2}>
                    <Box>
                      <Box className="label">Leave Entitlement</Box>
                      <Box className="value">{config.leave_days}</Box>
                    </Box>
                  </Col>
                  <Col md={5} xl={2}>
                    <Box>
                      <Box className="label">Unused Leave</Box>
                      <Box className="value">
                        {config.unuse_leave === "carried_forward"
                          ? "Carry forward"
                          : "Forfeited"}
                      </Box>
                    </Box>
                  </Col>
                  <Col>
                    <Box>
                      <Box className="label">Carry Forward Limit</Box>
                      <Box className="value">
                        {config.unuse_leave === "carried_forward"
                          ? config.cf_limit
                          : "N/A"}
                      </Box>
                    </Box>
                  </Col>
                  <Col sm={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbPencil />}
                        onClick={() => handleEditModalOpen(config)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>


            ))}
          </Flex>
          <Box mt={20}>
            <Flex alignItem="center" justifyContent="center" gap={10}>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === 1}
                onClick={() => handlePagination("previous")}
              >
                Previous
              </Button>
              <Typography
                variant="body2"
                mb="0"
                color="dark"
                colorvariant="light"
              >
                Page {pagination.page} of {pagination.totalPages}
              </Typography>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === pagination.totalPages}
                onClick={() => handlePagination("next")}
              >
                Next
              </Button>
            </Flex>
          </Box>
        </>
      )}

      {/* Details-view */}

      {/* Create Full time employee */}
      <Dialog
        title={
          isEditMode ? "Update Full time employee" : "Create Full time employee"
        }
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Leave Type"
              options={adminLeaveListsInfo}
              placeholder="Select Here..."
              defaultValue={leave.leave_type_id}
              onChange={(val) => handleChange(val, "leave_type_id")}
              error={errors.leave_type_id}
              helperText={errors.leave_type_id}
              onBlur={(e) => handleBlurFn(e, "leave_type_id")}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Leave Entitlement"
              type="number"
              placeholder="Type Here"
              valueSinc
              // valueSinc={!!leave.leave_days}
              value={leave.leave_days}
              onChange={(e) => handleChange(e.target.value, "leave_days")}
              helperText={errors.leave_days}
              error={errors.leave_days}
              onBlur={(e) => handleBlurFn(e, "leave_days")}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Impact of Unused Leave"
              options={[
                { id: "carried_forward", name: "Carried Forward" },
                { id: "forfeited", name: "Forfeited" },
              ]}
              placeholder="Select Here..."
              defaultValue={leave.unuse_leave}
              onChange={(val) => handleChange(val, "unuse_leave")}
              error={errors.unuse_leave}
              helperText={errors.unuse_leave}
              onBlur={(e) => handleBlurFn(e, "unuse_leave")}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Carry Forward Limit"
              type="number"
              placeholder="Type Here"
              valueSinc
              // valueSinc={!!leave.cf_limit}
              value={leave.cf_limit}
              disabled={leave.unuse_leave !== "carried_forward"}
              required={leave.unuse_leave === "carried_forward"}
              onChange={(e) => handleChange(e.target.value, "cf_limit")}
              helperText={errors.cf_limit}
              error={errors.cf_limit}
              onBlur={(e) => handleBlurFn(e, "cf_limit")}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Create Full time employee  */}
    </>
  );
};
export default OrganizationFullTimeEmployee;
